<template>
  <div>
    <h4 class="mb-2">{{ $t("alerts.wizard.actionMode.title") }}</h4>
    <slot name="checkbox" />

    <fieldset class="ml-10" v-if="isSelected">
      <!--   Action Plan   -->
      <wx-select
        v-model="reactiveValue.actionPlanId"
        :label="$t('alerts.wizard.actionMode.actionPlan')"
        :items="actionPlans"
        item-value="id"
        item-text="name"
        :rules="[validActionPlan]"
      />
      <!--   Name   -->
      <wx-text-field
        v-model="reactiveValue.name"
        :label="$t('alerts.wizard.actionMode.name')"
        :rules="[validName]"
        :dense="false"
      />
      <!--   Description   -->
      <wx-textarea
        v-model="reactiveValue.description"
        :label="$t('alerts.wizard.actionMode.description')"
      />
      <!-- Assignee -->
      <wx-select
        v-model="reactiveValue.assignedUserId"
        :items="factoryUsers"
        :label="$t('alerts.wizard.actionMode.assignee')"
        clearable
        item-value="id"
        item-text="display_name"
      />
      <!-- Priority -->
      <wx-select
        v-model="reactiveValue.priority"
        :items="priorities"
        :label="$t('alerts.wizard.actionMode.priorities.title')"
        item-text="label"
        item-value="value"
      />
    </fieldset>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import WxTextarea from "@/components/ui/WxTextarea.vue";
import WxTextField from "@/components/ui/WxTextField.vue";
import WxSelect from "@/components/ui/WxSelect.vue";
import ActionPlanService from "@/components/alerts/ActionPlanService";

export default {
  name: "ActionMode",
  components: {
    WxSelect,
    WxTextarea,
    WxTextField,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        actionPlanId: null,
        priority: "medium",
        taskName: "",
        taskDescription: "",
        assignee: null,
      }),
    },
    alert: {
      type: Object,
      default: null,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      actionPlans: [],
      defaultActionPlanId: null,
      userSearch: null,
      userErrorMessages: [],
    };
  },
  computed: {
    ...mapGetters("navigation", ["factoryUsers", "activeFactory"]),
    ...mapGetters("user", ["language"]),
    reactiveValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
    priorities() {
      return [
        { value: "highest", label: this.$t("alerts.wizard.actionMode.priorities.highest") },
        { value: "high", label: this.$t("alerts.wizard.actionMode.priorities.high") },
        { value: "medium", label: this.$t("alerts.wizard.actionMode.priorities.medium") },
        { value: "low", label: this.$t("alerts.wizard.actionMode.priorities.low") },
        { value: "lowest", label: this.$t("alerts.wizard.actionMode.priorities.lowest") },
      ];
    },
  },
  methods: {
    validName(name) {
      if (!name || name.trim().length === 0) {
        return this.$t("productionUnit.errors.noName");
      }
      return true;
    },
    validActionPlan(actionPlanId) {
      if (!actionPlanId || actionPlanId.trim().length === 0) {
        return this.$t("alerts.wizard.actionMode.errors.noActionPlan");
      }
      return true;
    },
    initializeData() {
      if (this.alert?.action_plan_task_template) {
        this.reactiveValue = {
          actionPlanId: this.alert.action_plan_task_template.action_plan_id ?? this.defaultActionPlanId,
          priority: this.alert.action_plan_task_template.priority ?? "medium",
          name: this.alert.action_plan_task_template.name ?? null,
          description: this.alert.action_plan_task_template.description ?? null,
          assignedUserId: this.alert.action_plan_task_template.assigned_user_id ?? null,
        };
      } else {
        this.reactiveValue = {
          actionPlanId: this.defaultActionPlanId,
          priority: "medium",
          name: null,
          description: null,
          assignedUserId: null,
        };
      }
    },
    fetchActionPlans() {
      ActionPlanService.getActionPlans(this.activeFactory.id)
        .then((response) => {
          this.actionPlans = response.data.map((ap) => ({
            id: ap.id,
            name: ap.name === "default" ? this.$t("alerts.wizard.actionMode.defaultActionPlanName") : ap.name,
          }));
          this.defaultActionPlanId = response.data.find((ap) => ap.name === "default")?.id ?? null;
          this.initializeData();
        })
        .catch((error) => {
          console.log(error);
          this.actionPlans.value = [];
        });
    },
  },
  mounted() {
    this.fetchActionPlans();
  },
};
</script>
